import { format, parseISO, isToday, isTomorrow, isYesterday, differenceInDays } from 'date-fns';

/**
 * Format a date for display
 */
export function formatDate(date, formatStr = 'MMM d, yyyy') {
  if (!date) return '';
  const d = typeof date === 'string' ? parseISO(date) : date;
  return format(d, formatStr);
}

/**
 * Format date with relative context (Today, Tomorrow, etc.)
 */
export function formatDateRelative(date) {
  if (!date) return '';
  const d = typeof date === 'string' ? parseISO(date) : date;
  
  if (isToday(d)) return 'Today';
  if (isTomorrow(d)) return 'Tomorrow';
  if (isYesterday(d)) return 'Yesterday';
  
  const diff = differenceInDays(d, new Date());
  if (diff > 0 && diff <= 7) {
    return format(d, 'EEEE'); // Day name
  }
  
  return format(d, 'MMM d');
}

/**
 * Format time (24h to 12h)
 */
export function formatTime(time) {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  const h = parseInt(hours);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 || 12;
  return `${h12}:${minutes} ${ampm}`;
}

/**
 * Format time range
 */
export function formatTimeRange(start, end) {
  return `${formatTime(start)} - ${formatTime(end)}`;
}

/**
 * Format currency
 */
export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Format percentage
 */
export function formatPercent(value) {
  return `${parseFloat(value).toFixed(1)}%`;
}

/**
 * Get margin status based on percentage
 */
export function getMarginStatus(percent) {
  const p = parseFloat(percent);
  if (p >= 30) return 'good';
  if (p >= 25) return 'warning';
  return 'bad';
}

/**
 * Get status badge class
 */
export function getStatusBadgeClass(status) {
  const statusMap = {
    PENDING: 'badge-pending',
    CONFIRMED: 'badge-confirmed',
    ACCEPTED: 'badge-accepted',
    COMPLETED: 'badge-completed',
    CANCELLED: 'badge-cancelled',
    DECLINED: 'badge-declined',
  };
  return statusMap[status] || 'badge';
}

/**
 * Parse ISO date string to Date object
 */
export function parseDate(dateStr) {
  if (!dateStr) return null;
  return parseISO(dateStr);
}

/**
 * Get current pay period info
 */
export function getCurrentPayPeriod() {
  const now = new Date();
  const day = now.getDate();
  const month = now.getMonth();
  const year = now.getFullYear();
  
  if (day <= 15) {
    return {
      period: 1,
      startDate: new Date(year, month, 1),
      endDate: new Date(year, month, 15),
      payDate: new Date(year, month, 15),
      label: `${format(now, 'MMM')} 1-15`,
    };
  } else {
    const lastDay = new Date(year, month + 1, 0).getDate();
    return {
      period: 2,
      startDate: new Date(year, month, 16),
      endDate: new Date(year, month, lastDay),
      payDate: new Date(year, month, lastDay),
      label: `${format(now, 'MMM')} 16-${lastDay}`,
    };
  }
}
